import React, { Component } from "react";
import isEqual from "lodash/isEqual";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import Table, { Toolbar, TextInput } from "../../../components/Table";

const columns = ({ onChange }) => [
  { dataKey: "width", title: "Width", element: <TextInput type="number" onChange={onChange} /> },
  { dataKey: "length", title: "Length", element: <TextInput type="number" onChange={onChange} /> }
];

class WidthVariationDialog extends Component {
  state = {
    rows: [],
    rowCount: 3
  };

  componentDidMount() {
    this.init(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.layRow, nextProps.layRow)) {
      this.init(nextProps);
    }
  }

  init = props => {
    const { layRow = {} } = props;
    let rows = layRow.remarks ? JSON.parse(layRow.remarks) : [];
    for (let i = rows.length; i < 3; i++) {
      rows.push({});
    }
    this.setState({ rows });
  };

  onChange =
    ({ rowIdx, column }) =>
    e => {
      let rows = this.state.rows.slice();
      rows[rowIdx][column.dataKey] = e.target.value;
      this.setState({ rows });
    };

  onAddRow = () => {
    let { rowCount, rows } = this.state;
    rows.push({});
    this.setState({ rows, rowCount: rowCount + 1 });
  };

  onClose = () => {
    const rows = this.state.rows.filter(row => row.length || row.width);
    this.props.onClose(rows);
  };

  render() {
    const { open } = this.props;
    if (!open) return null;
    return (
      <Dialog open={open} fullWidth={true} maxWidth="xs" onClose={this.onClose}>
        <DialogTitle style={{ padding: 0 }}>
          <Toolbar title="Width Variation" actions={[{ name: "add", tooltip: "Add Row", onClick: this.onAddRow }]} />
        </DialogTitle>
        <Divider />
        <DialogContent style={{ padding: 0 }}>
          <Table columns={columns({ onChange: this.onChange })} rows={this.state.rows} />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={this.onClose}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default WidthVariationDialog;
